import { pathJoin } from 'src/reducers/routing/utils'

export const createPickupSettingsDetailViewRoutesMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  'collection-calendar': pathJoin(prefix)('collection-calendar').chain,
  'collection-calendar-days': pathJoin(prefix)('collection-calendar-days')
    .chain,
})
